import create from "zustand"
import { User, Challenge } from "../sdk"

type UserStore = {
  user: User | null
  setUser(user: User | null): void
  subscriptions: Challenge[] | null
  setSubscriptions(subscriptions: Challenge[]): void
  reset(): void
}

const defaultState: Pick<UserStore, "user" | "subscriptions"> = {
  user: null,
  subscriptions: null
}

export const useUser = create<UserStore>((set) => ({
  user: null,
  subscriptions: null,
  setUser: (user: User | null): void => set({ user }),
  setSubscriptions: (subscriptions: Challenge[] | null): void => set({ subscriptions }),
  reset: (): void => set((state) => ({ ...state, ...defaultState }))
}))